const DELIVERY_DATETIME_LABELS = {
  furniture: ['家具配送希望日', '家具配送希望時間帯'],
  misc: ['雑貨配送希望日', '雑貨配送希望時間帯'],
  curtain: ['お届け希望日', '配送希望時間帯'],
}

export { DELIVERY_DATETIME_LABELS }
